import { Routes, Route } from 'react-router-dom';
import GroupList from './GroupList';
import GroupDetail from './GroupDetail';

/**
 * 用户组管理子模块路由。列表 / 详情均为模块内部路由，
 * 对外只暴露挂载点 `/iam/groups/*`，与 users 子模块保持一致的结构。
 */
export default function IamGroupsRoutes() {
  return (
    <Routes>
      <Route index element={<GroupList />} />
      <Route path=":id" element={<GroupDetail />} />
    </Routes>
  );
}
